<template>
  <div class="header" ref="myNav">
    <div class="header-content clear" ref="myNav">
      <div class="logo fl">
         <a href="http://breadoffer.com"><img src="../../../static/img/logo3.svg" alt=""></a>
         <!-- Logo右侧标签(根据列表页、详情页的路由名切换标签内容,搜索页默认显示学院) -->
         <!-- <span v-for="(item,index) in routeArr" v-if="pathName == item.listPath || pathName == item.detailPath">{{item.simpleName}}</span>
         <span v-else-if="pathName == 'Search'">学院</span>
         <span v-else>学院</span> -->
      </div>
       <!-- 头部导航列表 -->
       <div class="site-nav fl">
         <ul class="nav-list fl clear">
         	<li class="decorate" ref="decorate" :style="'left:' + decorateLeft + 'px'"></li>
          <!-- 路由切换(遍历路由数组routeArr,to为动态添加地址，需写为绑定属性，加:) -->
          <li class="nav-item" v-for="(item,index) in routeArr" :class="{'link':pathName == item.detailPath}" @mouseenter="changeLeft(index)" @mouseleave="backLeft()">
            <a :href='item.url' :key="item.id" class="route-link" :class="{'activityColor':formName === item.listPath || formName === item.detailPath}">{{item.name}}</a>
          </li>
          <!-- 头部搜索 -->
          <!-- <li class="nav-item item-input" v-show="pathName != 'Search'" >
            <input type="text" name="" value="" ref="myInput" :placeholder="holder" :style="'width:' + inputWidth + 'px'" @focus="handleFocus"  @blur="handleBlur" @mouseenter="enter" @mouseleave="leave" @keydown.13="search">
            <i class="iconfont search-icon" @click="search">&#xe61f;</i>
          </li> -->
         </ul>
         <!-- 引入登录组件(loginCssStatus:控制搜索页的登录/注册样式) -->
         <v-login :loginCssStatus='loginCssStatus' class="fl"></v-login>
       </div>
     </div>
  </div>
</template>

<script>
import Login from '../common/login'; // 引入已登录样式组件
import $ from 'jquery';

export default{
  components:{
    'v-login':Login,
  },
  data(){
    return {
      baceUrl:'http://member.breadoffer.com/', // 登录、注册基本路径
      pathName: '', // 路由名
      formName:'', // url中form参数
      width: 75, // 默认头部导航宽度
      decorateLeft: 75, // 头部跟随导航条左偏移量
      index: '', // 头部导航下标
      inputWidth: '', // 搜索框宽度(用于动画效果)
      holder: '搜索', // 搜索框默认placeholder
      keywords: '', // 搜索框关键词
      loginCssStatus: false, // 控制搜索页的登录/注册样式
      // 路由切换、logo右侧标签内容
      routeArr: [
        {name:'首页',url:'http://breadoffer.com',listPath:'Index',detailPath:'', simpleName:'首页'},
        {name:'内推',url:'http://college.breadoffer.com/recruit/inner/list',listPath:'RecruitInner',detailPath:'RecruitInnerDetail', simpleName:'内推'},
        {name:'课程',url:'http://breadoffer.com/course/list.html',listPath:'Course',detailPath:'KnowledgeDetail', simpleName:'干货'},
        {name:'导师',url:'http://breadoffer.com/teacher/list.html',listPath:'Teacher',detailPath:'KnowledgeDetail', simpleName:'干货'},
        {name:'成果',url:'http://breadoffer.com/gain.html',listPath:'Knowledge',detailPath:'KnowledgeDetail', simpleName:'干货'},
        {name:'关于',url:'http://breadoffer.com/aboutus/index.html',listPath:'Knowledge',detailPath:'KnowledgeDetail', simpleName:'干货'}
        // {name:'活动',url:'/activity/list',listPath:'Activity',detailPath:'ActivityDetail', simpleName:'活动'},

        // {name:'招聘',url:'/recruit/outer/list',listPath:'RecruitOuter',detailPath:'RecruitOuterDetail', simpleName:'招聘'},
        // {name:'新闻',url:'/industry/list',listPath:'Industry',detailPath:'IndustryDetail', simpleName:'新闻'},
      ]
    }
  },
  methods:{
  	//鼠标移入时导航条跟随效果
  	changeLeft(index){
			this.decorateLeft = this.width * index;
  	},
  	//鼠标移出时导航条恢复默认位置
  	backLeft(){
      var currentPath = this.$route.query.form || this.pathName;
      //index的值：搜索页根据路径中的form参数，其他页根据路由的pathName值
      //findIndex：返回满足条件的元素的索引值
      if(currentPath !== 'Error'){ // 从404/下架页面跳转到搜索页导航条默认left为0
        let index = this.routeArr.findIndex(function(element, index, array){
          return currentPath == element.listPath || currentPath == element.detailPath;
        });
        // console.warn('decorateLeft', this.decorateLeft)
        this.decorateLeft = this.width * index; // 跟随条左偏移量的值
      }else{
        this.decorateLeft = this.width * 0; // 404页面默认left为0
      }
      this.decorateLeft = 75;
  	},
    //获取当前页面路径，改变标签文字
    pathFn(){
      this.pathName = this.$route.name;
      this.formName = this.GetQueryString("form");
		  //搜索页头部无搜索框,登陆/注册按钮靠右侧的样式
      this.loginCssStatus = (this.pathName === 'Search')
      //切换路由时，需要初始化的函数
      $("input[type='text']").val(''); // 搜索框恢复默认
      this.initTop(); // 初始化滚动条
      this.backLeft(); // 导航跟随条恢复默认位置
      this.leave(); // 搜索框鼠标移出
      this.fixedNav(); // 监听滚动条，改变样式
    },
    //切换路由，初始化滚动条高度
    initTop(){
    	document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
    },
    //监听滚动条，改变导航样式
    fixedNav(){
			this.$nextTick(() => {
				let tops = document.body.scrollTop || document.documentElement.scrollTop;//同时兼容谷歌与火狐
				if(tops >= this.top){
					this.nav.className = 'header';
				}
        //如果是内推和招聘页，头部导航改为透明背景的样式,其他页为白色背景
				if(tops == 0 && (this.pathName == 'RecruitInner' || this.pathName == 'RecruitOuter')){
					this.nav.className = 'active';
				}else{
					this.nav.className = 'header';
				}
			})
		},
	  // 搜索框移入移出事件
	  handleFocus(){
	  	this.holder = '';
	  },
	  handleBlur(){
	  	this.holder = '搜索';
	  },
	  enter(){
	  	this.inputWidth = 250; // 鼠标移入，输入框长度变为250px;
	  },
	  leave(){
	  	if($("input").is(":focus")){
	  		this.inputWidth = 250; // 当鼠标移出,并且此时input已获取焦点，长度变为250px;
	  	}else{
	  		this.inputWidth = 150; // 当鼠标移出,但此时input未获取焦点，长度仍为150px;
	  	}
	  },
    //点击搜索函数
    search(){
      this.keywords = $.trim(this.$refs.myInput.value)
      if(this.keywords){
        this.$router.push({path:'/search',query:{ keywords:this.keywords,form:this.$route.name}}); // 切换搜索路由，用query传递参数
      }else{
      	this.$router.push({path:'/search',query:{ keywords:'',form:this.$route.name}})
      }
    },
    GetQueryString(name){
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if(r!=null)return  unescape(r[2]); return null;
    }
  },
  //在计算属性中获取导航距离顶端的高度
  computed:{
    top(){
			return this.nav.offsetTop;
		}
  },
  mounted(){
    this.nav = this.$refs.myNav; // 获取头部导航元素
    this.pathFn();
    this.fixedNav();
    window.addEventListener('scroll',this.fixedNav);
  },
  //监听路由变化
  watch:{
  	"$route":"pathFn",//路由变化时，改变标签内容
	  // "pathName":"fixedNav" // 标签内容改变时，改变导航样式
  },
}
</script>

<style scoped lang="scss">
@import  "../../sass/mixin";
// 内推、招聘列表页头部样式
#app{
  .active{
    width:100%;
    height:67px;
    line-height: 67px;
    position: fixed;
    top:0;
    z-index: 101;
    font-size:14px;
    @include transition(all 0.4s);
    .header-content{
      .site-nav{
        .nav-list{
          // margin-left: 340px;
          .nav-item{
            .route-link{
              display: inline-block;
              width:100%;
              height:100%;
              color:#e5e5e5;
            }
            &:hover{
              .route-link{
                color:#fdcf3a;
              }
            }
          }
        }
        // 当前路由默认添加class值：router-link-active
        .router-link-active{
          color:#fdcf3a !important;
        }
      }
      input{
        background-color: #fff;
      }
    }
  }
}

// 其他页面头部样式
.header{
    width:100%;
    height:67px;
    line-height: 67px;
    position: fixed;
    top:0;
    z-index: 101;
    background-color: #fff;
    // border-bottom: 1px solid #e5e5e5;
    box-shadow:0 0 10px 0 rgba(0,0,0,0.1);
    font-size:14px;
    @include transition(all 0.4s);
    .nav-item{
      .route-link{
        display: inline-block;
        width:100%;
        height:100%;
      }
      &:hover{
    	  .route-link{
    	    color:#e2ab14;
    	  }
    	}
      // 404、下架、搜索等页面导航字体对应的样式
      .activityColor{
        color:#e2ab14;
      }
    }
    //详情页中的样式
    .link{
      .route-link{
        color:#e2ab14 !important;
      }
    }
    .router-link-active {
      color:#e2ab14 !important;
    }
  }
  .header-content{
    width:1170px;
    margin:$mc;

    .logo{
      width:90px;
      height:67px;
      margin-right:123px;
      position: relative;
        img{
          width:100%;
          display: inline-block;
        }
        span{
          width:48px;
          height:21px;
          font-size:12px;
          position: absolute;
          right:-55px;
          top:24px;
          color:#343331;
          display: inline-block;
          line-height: 21px;
          text-align: center;
          background-color: #f8d85f;
          @include border-radius(3px);
        }
      }
    }

.nav-list{
	position: relative;
  margin-left: 340px;
	.decorate{
		width:75px;
		height:3px;
		position: absolute;
		top:0;
    left: 75px;
		background-color: #f8d85f;
		@include transition(all 0.3s);

	}
  .nav-item{
    float:left;
    width:75px;
    text-align: center;
    color:#5c5c5c;
  }
  .item-input{
    width:150px;
    margin:0 20px 0 176px;
    position: relative;
    input{
      width: 150px;
      height: 30px;
      float:right;
      line-height: 30px;
      color:#777;
      background-color: #fff;
      border:1px solid #eee;
      padding:0 35px 0 14px;
      margin-top:20px;
      @include border-radius(25px);
      @include transition(all 0.5s);
    }
    .search-icon{
      position: absolute;
      right:12px;
      top:2px;
      color:#9e9ea0;
      cursor:pointer;
    }
  }
  // .nav-item-buttons {
  //   width: 160px;
  //   text-align: right;
  //   a{
  //     @include border-radius(3px);
  //      background-color: #ffffff;
  //     @include transition(all 0.4s);
  //   }
  //   .button-default{
  //     padding:5px 15px 6px;
  //     border:1px solid #555555;
  //     margin-right:15px;
  //     @include border-radius(3px);
  //     @include transition(all 0.4s);
  //     &:hover{
  //     	color:#fff;
  //     	background-color: #555;
  //       @include transition(all 0.4s);
  //     }
  //   }
  //   .button-light{
  //     padding:6px 15px;
  //     background-color: #f8d85d;
  //     &:hover{
  //     	color:#555;
  //       background-color: #fdcf3a;
  //       @include transition(all 0.4s);
  //     }
  //   }
  // }
  // .right-active{
  // 	margin-left:340px;
  // }
}
</style>



// WEBPACK FOOTER //
// header.vue?3adbe84d